import { useCallback, useEffect, useState } from "react";
import adminApi from "../api/adminApi";

const ADMIN_SESSION_KEY = "admin_token";

function readStoredAdminToken() {
  try {
    return sessionStorage.getItem(ADMIN_SESSION_KEY) || "";
  } catch (_) {
    return "";
  }
}

function writeStoredAdminToken(token) {
  try {
    if (token) {
      sessionStorage.setItem(ADMIN_SESSION_KEY, token);
    } else {
      sessionStorage.removeItem(ADMIN_SESSION_KEY);
    }
  } catch (_) {
    // ignore storage issues
  }
}

export function useAdminAuth() {
  const [code, setCode] = useState("");
  const [adminToken, setAdminToken] = useState(() => readStoredAdminToken());
  const [verified, setVerified] = useState(() => Boolean(readStoredAdminToken()));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (adminToken) return;
    adminApi.generateCode().catch((error) => {
      console.error(error);
    });
  }, [adminToken]);

  const verify = useCallback(async () => {
    if (!code) return { success: false };
    setLoading(true);
    try {
      const res = await adminApi.verifyCode(code);
      if (res.data?.success) {
        const nextToken = res.data.adminToken || "";
        setVerified(true);
        setAdminToken(nextToken);
        writeStoredAdminToken(nextToken);
        return { success: true, adminToken: nextToken };
      }

      const message = res.data?.error || "Неверный код";
      window.alert(message);
      return { success: false, error: message };
    } catch (error) {
      console.error(error);
      window.alert("Ошибка сервера");
      return { success: false, error };
    } finally {
      setLoading(false);
    }
  }, [code]);

  const logout = useCallback(() => {
    setCode("");
    setVerified(false);
    setAdminToken("");
    writeStoredAdminToken("");
  }, []);

  return {
    code,
    setCode,
    verified,
    loading,
    adminToken,
    verify,
    logout
  };
}

export default useAdminAuth;
